// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2837":"3466688d91092bcc","2888":"2b6b6639a2aa04cc"}[chunkId] + ".css";
};